import sanitizeHtml from 'sanitize-html'

// Element-stripping runs first so head/style/script content never survives into the body text.
// sanitize-html's parser then resolves every named, decimal and hex entity (`&mdash;`, `&#8212;`,
// `&#x2014;`) and re-escapes only `& < >`; those three are decoded last, `&amp;` final, so an
// already-escaped entity (`&amp;lt;`) is not decoded twice.
export const htmlToPlainText = (html?: string): string => {
  // a `<` left after the tag strip is text, not a tag — escaped so the parser keeps what follows it
  const text = (html ?? '')
    .replace(/<(head|style|script)\b[^>]*>[\s\S]*?<\/\1>/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .replace(/<a\b[^>]*href=["']([^"']*)["'][^>]*>([\s\S]*?)<\/a>/gi, '$2 ($1)')
    .replace(/<(\/td|\/th)\b[^>]*>/gi, ' ')
    .replace(/<(br|\/p|\/div|\/li|\/h[1-6]|\/tr)\b[^>]*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/</g, '&lt;')

  return sanitizeHtml(text, { allowedTags: [], allowedAttributes: {} })
    .replace(/\u00a0/g, ' ')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/[ \t\r]+/g, ' ')
    .replace(/[ \t\r]*\n[ \t\r]*/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
